export enum IndicatorStyle {
    STEP_REOPENED = 'step-reopened',
    STEP_APPROVED = 'step-approved',
    STEP_COMPLETED = 'step-completed',
    STEP_SUBMITTED = 'step-submitted',
    DECLINED = 'declined',
    FORGIVEN = 'forgiven',
    NUDGED = 'nudged',
    MESSAGE = 'message',
    CREATED = 'created',
    // Reuses the existing `.step-followup` SCSS class (already defined, previously
    // unused) rather than adding new styling.
    DUE_DATE_CHANGED = 'step-followup',
    NONE = ''
}